export enum SiteTemplateUseCase {
    Portfolio = 'portfolio',
    Starter = 'starter',
    Events = 'events',
    Ecommerce = 'ecommerce',
    Documentation = 'documentation',
    Blog = 'blog',
    Ai = 'ai',
    Forms = 'forms',
    Dashboard = 'dashboard',
}
